import { useParams } from 'react-router-dom';

import { DawnChartGraph, IconGradient } from '@xemplo/icons';
import { useGetPayscheduleByIdQuery } from '@xemplo/pay-schedule-query';

import { getFieldsArray } from './external-pay-schedule-card.helpers';
import * as S from './external-pay-schedule-card.styles';

export function ExternalPayScheduleCard(props: { className?: string }) {
  const { payscheduleId } = useParams<{ payscheduleId: string }>();
  const { data } = useGetPayscheduleByIdQuery({ id: payscheduleId });

  if (!data?.result?.externalPayrollConnection) {
    return null;
  }

  const fields = getFieldsArray(data.result.externalPayrollConnection);

  return (
    <S.CardContainer className={props.className}>
      <S.Header>
        <S.IconWrapper>
          <DawnChartGraph fontSize={24} />
          <IconGradient />
        </S.IconWrapper>
        <S.Title>External Pay Schedule</S.Title>
      </S.Header>

      <S.FieldsGrid>
        {fields.map((field) => (
          <S.Field key={field.id}>
            <S.Label>{field.label}</S.Label>
            <S.Value>{field.value}</S.Value>
          </S.Field>
        ))}
      </S.FieldsGrid>
    </S.CardContainer>
  );
}
